import { importComponents } from '~/helpers'

export default {
    components: importComponents(require.context('components/page-elements')),
}
